export default "__VITE_ASSET__CKtXRXTr__"